import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-card-payment-details',
    templateUrl: './card-payment-details.component.html',
    styleUrls: ['./card-payment-details.component.css'],
    standalone: false
})
export class CardPaymentDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
